import axios from 'axios';
import { setAxiosRequestTokenInterceptor } from '../common/setAxiosRequestTokenInterceptor';
import { setAxiosResponseInterceptor } from './setAxiosResponseInterceptor';

export const posAxiosClient = axios.create();

setAxiosRequestTokenInterceptor(posAxiosClient);
setAxiosResponseInterceptor(posAxiosClient);
